import axios from 'axios'
const API_KEY = process.env.REACT_APP_CONTENT_API_KEY
const BASE_URL = process.env.REACT_APP_API_CONTENT_URL

async function contentData(endpoint) {
  try {
    const response = await axios.get(`${BASE_URL}/content/${endpoint}`, {
      headers: {
        api_key: API_KEY,
      },
    })
    response.data.success = true
    return response.data
  } catch (err) {
    return { success: false, message: err.response?.data }
  }
}

export const contentPage = async (pageName, language) => {
  return contentData(`pages/${pageName}/${language}`)
}

export const contentList = async (pageName, language) => {
  return contentData(`lists/${pageName}/${language}`)
}

export const questionsList = async (pageName, language, number) => {
  return contentData(`questions/${pageName}/${language}/${number}`)
}

export const allDropdownsList = async (pageName, language) => {
  return contentData(`${pageName}/${language}`)
}

export const sideBarSections = async (mapType, language) => {
  return contentData(`lists/lst_sections/${language}/${mapType}`)
}
